import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { callApi, CDN_URL, formatDate, formatMoneyShorten } from "../Helpers";
import { FaRegCommentDots } from "react-icons/fa";
import { MdAttachFile, MdPerson } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	
	
	function view(e) {
		e.stopPropagation();
		appContext.getUserInboxes();
		
		appContext.navTo({
			item: 'view',
			subItem: 'inbox',
			extraItem: data.id,
		});
	}

	function isUnread() {
		return (data.isLatestMessageRead === 'no' && Number(data.fromId) !== Number(appContext.currentUserData.id));
	}

	useEffect(() => {
		if(data) {
			//..
		}
	}, [data])

	return (
		<div
			style={{
				width: "100%",
				height: "auto",
				padding: "10px",
				marginBottom: "10px",
				borderRadius: "10px",
				border:  isUnread() ? "2px solid var(--secondaryColor)" : "none",
			}}
			onClick={view}
			className="bg-surface"
		>
			<div className="d-flex">
				<MdPerson
					size={64}
					className="text-primary"
					style={{
						flexShrink: 0,
					}}
				/>

				<div
					style={{
						flexGrow: 1,
						minWidth: "0px",
						paddingTop: "10px"
					}}
					className=""
				>
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-bold text-secondary"
					>
						{data.agentName || data.phone}
					</h6>

					<h6
						style={{
							fontSize: "14px",
							width: "100%"
						}}
						className={(isUnread()) ? "font-semi-bold mOneLineText" : "font-regular mOneLineText text-muted"}
					>
						{
							(data.latestAttachment) ?
							<MdAttachFile size={24}/>
							:""
						}

						{data.latestMessage}
					</h6>

					<h6
						style={{
							fontSize: "10px"
						}}
						className="font-bold text-muted text-end"
					>
						{formatDate(data.latestMessageTimestamp)}
					</h6>
				</div>
			</div>
		</div>
	);
}
